jQuery(document).ready(function($) {
  'use strict';

  // Show/hide primary navigation on click.
  $('.js-menu').click(function (e) {
    $(this).toggleClass('is-opened');
    $('.navigation--primary').toggleClass('is-opened');
  });

  // Close menu on close button click.
  $('.navigation__close').click(function (e) {
    $('.js-menu').removeClass('is-opened');
    $('.navigation--primary').removeClass('is-opened');
  });

  // Close menu on ESC keyup.
  $(document).keyup(function (e) {
    if (e.keyCode === 27) {
      $('.js-menu').removeClass('is-opened');
      $('.navigation--primary').removeClass('is-opened');
    }
  });

  // Masonry.
  setTimeout(function () {
    $('.grid--masonry').masonry({
      itemSelector: '.column'
    });
  }, 500);

  // Change search form placeholder text on focus in.
  $('.search__form__input').focusin(function (e) {
    $(this).attr('placeholder', 'Type here to search');
  });

  // Change search form placeholder text on focus out.
  $('.search__form__input').focusout(function (e) {
    $(this).attr('placeholder', 'Search');
  });

  // Slick.
  $('.js-slick-slider').slick({
    arrows: false,
    dots: true,
    draggable: false
  });

  // Share.
  $('.js-share').click(function (e) {
    e.preventDefault();
    var link = $(this).attr('href');
    window.open(link, 'share', 'height=350,width=600');
  });

  // Newsletter placeholder
  var newsletterPlaceholder = function () {
    var $input = $('.newsletter input');

    if ($('html').width() > 720) {
      $input.attr('placeholder', 'Be the first to know our new courses and freebies, enter your email /');
    } else {
      $input.attr('placeholder', 'Get the news /');
    };
  };

  newsletterPlaceholder();

  $(window).resize(function () {
    newsletterPlaceholder();
  });
});
